import React from 'react';

/**
 * The page title in the app title bar's left area.
 *
 * Owner, 20.10.2026: the small uppercase page titles ("BOARDS", "GRAPH", …)
 * and the page actions are gone from the title bar. The project switcher says
 * where you are, and every action lives in its page:
 *
 *   Vault        "⋯" menu beside the vault search (components/VaultActionsMenu)
 *   DB Manager   New connection + Refresh in the sidebar's action row
 *   FTP          New connection button in the sidebar
 *   Terminal     the New terminal menu in the tab strip
 *   Calendar     New event in the calendar toolbar
 *   Mail         Clear all in the mail toolbar
 *   Git          Check status in the Git page header
 *
 * Only the Vault keeps its title: it has no project switcher, so the title bar
 * would otherwise say nothing about the page. The name stays for the title
 * bar's existing call site.
 */
const TITLES = Object.freeze({ 'vault.panel': 'Vault' });

export const titleBarTitleFor = (panelId) => TITLES[panelId] || null;

export default function ExtensionTitleBarActions({ panelId }) {
  const title = titleBarTitleFor(panelId);
  if (!title) return null;
  return (
    <div className="flex items-center gap-2 pl-2">
      <h2
        className="font-semibold text-gray-700 uppercase tracking-wide dark:text-zinc-400 leading-none m-0"
        style={{ fontSize: 12 }}
      >
        {title}
      </h2>
    </div>
  );
}
